import { axios } from '@kiper/fns';

export default axios.createHttpConnection();
